import React, { ReactNode } from 'react';
import { Container, Title, Text } from '@soluto-design/react';

export interface RichTextSectionProps {
    title?: string;
    text?: ReactNode;
}

export default function RichTextSection({ title, text }: RichTextSectionProps) {
    return (
        <section className="mt-extra mb-mega before:!min-h-0">
            <Container className="row">
                <div className="col-span-full lg:col-span-6 lg:col-start-2 xl:col-span-8 xl:col-start-3">
                    {title && (
                        <Title
                            component="h1"
                            className="text-h100 md:text-center pb-xxl">
                            {title}
                        </Title>
                    )}
                    {text && (
                        <Text
                            isHtml
                            component="div"
                            className="prose prose-richtext block md:pr-56 xl:pr-64">
                            {text}
                        </Text>
                    )}
                </div>
            </Container>
        </section>
    );
}
